import React from "react";

import { HOMEPAGE_V2 } from "@config/testIds/app";

import { SERVICE_TYPE } from "@typings/globals";

import { useConfig } from "@hooks/useConfig";
import { useTranslate } from "@hooks/useTranslate";
import { useTelemetry } from "@hooks/useTelemetry";

import { FIELD } from "../ServiceSelector.types";
import { SelectOption } from "../Select/Select.types";
import { Select } from "../Select";

import { getServicesOptions } from "./ServiceField.helpers";

export const ServiceField: React.FC = () => {
  const translate = useTranslate();
  const { sendEvent } = useTelemetry();

  const availableServices = useConfig<SERVICE_TYPE[]>(["availableServices"]);
  const servicesOptions = getServicesOptions(translate, availableServices);

  const selectHandler = (option: SelectOption) => {
    sendEvent("service-selector-service-selected", {
      context: {
        ...option,
      },
    });
  };

  const focusHandler = () => {
    sendEvent("service-selector-service-focus");
  };

  const blurHandler = () => {
    sendEvent("service-selector-service-blur");
  };

  return (
    <Select
      testId={HOMEPAGE_V2.HERO_SERVICES_DROPDOWN}
      name={FIELD.SERVICE}
      options={servicesOptions}
      isNativeReady
      onSelect={selectHandler}
      onFocus={focusHandler}
      onBlur={blurHandler}
    />
  );
};
